const baseAuth = "/admin/auth/";

export const auth = {
  login: "/admin/auth/user/login",
  signout: "/auth/signout",
  forgotPass: "/forgot-pass",
  changePass: `${baseAuth}profile/changepass`,
  profile: `${baseAuth}profile`,
  refreshToken: `${baseAuth}user/refreshtoken`,
  resetPass: `${baseAuth}emp/resetpass`,
  menu: `${baseAuth}menu`,
};

export const app = {
  menus: "/main/menu",
  profile: "/main/profile",
  password: "/main/change-pass",
  sysData: "/check-session",
};

/* BEGIN DICT */
const DictPath = "/admin/cust/dicts/";
export const dict = {
  many: `/admin/cust/dicts`,
  custType: `${DictPath}CustType`,
  gender: `${DictPath}CustPersonGender`,
  marriage: `${DictPath}Marriage`,
  addressType: `${DictPath}CustAddrType`,
  employment: `${DictPath}Employment`,
  city: `${DictPath}PaCity`,
  dist: `${DictPath}PaDist`,
  subDist: `${DictPath}PaSubDist`,
  nation: `${DictPath}PaNation`,
  business: `${DictPath}CustBus`,
  profession: `${DictPath}CustProf`,
  education: `${DictPath}CustEdu`,
  infoSrc: `${DictPath}CustInfoSrc`,
  relationType: `${DictPath}CustRelType`,
  collCat: `${DictPath}CollCat`,
  collType: `${DictPath}CollType`,
  lnCustProd: `${DictPath}LnCustProd`,
  custAcntNoteType: `${DictPath}NoteType`,
  custChannelType: `${DictPath}NoteChannel`,
};
/* END DICT */

const baseUrlAdmin = "/emp/";
export const admin = {
  admins: `${baseUrlAdmin}employees`,
  admin: `${baseUrlAdmin}employee`,
};

const baseUrlCust = "/admin/cust/";
export const cust = {
  fintCntrDoc: `${baseUrlCust}fintech/lncntr`,
  acntChangeLo: `${baseUrlCust}fintech/change-lo`,
  customers: `${baseUrlCust}customers`,
  persons: `${baseUrlCust}persons`,
  person: `${baseUrlCust}person`,
  orgs: `${baseUrlCust}orgs`,
  org: `${baseUrlCust}org`,
  businesses: `${baseUrlCust}buses`,
  business: `${baseUrlCust}bus`,
  professions: `${baseUrlCust}pstns`,
  profession: `${baseUrlCust}pstn`,
  educations: `${baseUrlCust}edus`,
  education: `${baseUrlCust}edu`,
  nations: `${baseUrlCust}nations`,
  cities: `${baseUrlCust}cities`,
  dists: `${baseUrlCust}dists`,
  subDists: `${baseUrlCust}subdists`,
  infoSrcs: `${baseUrlCust}info-srcs`,
  infoSrc: `${baseUrlCust}info-src`,
  pics: `${baseUrlCust}pics`,
  pic: `${baseUrlCust}pic`,
  bankAcnts: `${baseUrlCust}bankacnt`,
  bankAcnt: `${baseUrlCust}bankacnt`,
  bankAcntLogs: `${baseUrlCust}bankacnt/logs`,
  addresses: `${baseUrlCust}addrs`,
  address: `${baseUrlCust}addr`,
  relations: `${baseUrlCust}relations`,
  relation: `${baseUrlCust}relation`,
  relationType: `${baseUrlCust}relation/type`,
  contact: `${baseUrlCust}contact`,
  noteTypes: `${baseUrlCust}note/types`,
  noteType: `${baseUrlCust}note/type`,
  notes: `${baseUrlCust}notes`,
  note: `${baseUrlCust}note`,
  fintech: `${baseUrlCust}fintech`,
  fintChangeLimit: `${baseUrlCust}fintech/limit`,
  fintCntr: `${baseUrlCust}fintech/cntr/create`,
  fintCancel: `${baseUrlCust}fintech/cntr/cancel`,
  fintRestore: `${baseUrlCust}fintech/cntr/restore`,
  fintReturn: `${baseUrlCust}fintech/cntr/rqst/return`,
  fintDeny: `${baseUrlCust}fintech/cntr/rqst/deny`,
  fintCntrRestore: `${baseUrlCust}fintech/cntr/rqst/restore`,
  fintWaitListIn: `${baseUrlCust}fintech/waitlist/in`,
  fintWaitListOut: `${baseUrlCust}fintech/waitlist/out`,
  fintBlackListIn: `${baseUrlCust}fintech/blacklist/in`,
  fintBlackListOut: `${baseUrlCust}fintech/blacklist/out`,
  fintCntrExtAllow: `${baseUrlCust}fintech/cntr/ext/rqst/allow`,
  fintCntrExtDeny: `${baseUrlCust}fintech/cntr/ext/rqst/deny`,
  fintChangeIsCheckLn: `${baseUrlCust}fintech/change-checkln`,
  fintCntrExtReturn: `${baseUrlCust}fintech/cntr/ext/rqst/return`,

  fintCntrRqst: `${baseUrlCust}fintech/cntr/rqst`,

  products: `${baseUrlCust}prods`,
  product: `${baseUrlCust}prod`,
  limitHist: `${baseUrlCust}fintech/limit/hists`,
  contract: `${baseUrlCust}contract`,
  psyScrResult: `${baseUrlCust}psy-score/result`,
  nbfiScrList: `${baseUrlCust}fintech/nbfiscr/list`,
  nbfiScrDetail: `${baseUrlCust}fintech/nbfiscr/detail`,
  finInfo: `${baseUrlCust}fininfo`,
  changePhone: `${baseUrlCust}contact/phone`,
  changeRegNo: `${baseUrlCust}customer/regno`,
  zmsLatest: `${baseUrlCust}pcr/data`,
  zmsNew: `${baseUrlCust}pcr/download`,
  zmsLog: `${baseUrlCust}pcr/rqst`,
  zmsSend: `${baseUrlCust}pcr/send `, // TODO change later
  hurCardInfo: `${baseUrlCust}xyp/info`,
  hurMembers: `${baseUrlCust}xyp/members`,
  hurSalaryInfo: `${baseUrlCust}xyp/salary`,
  hurVehicleInfo: `${baseUrlCust}xyp/vehicle`,
  hurPropertyInfo: `${baseUrlCust}xyp/property`,
  hurAddressInfo: `${baseUrlCust}xyp/address`,
  hurMarriageInfo: `${baseUrlCust}xyp/marriage`,
  hurLog: `${baseUrlCust}xyp/rqsts`,

  //? Fint Issue
  fintIssueDict: `${baseUrlCust}fintech/issue/dict`,
  fintIssueDicts: `${baseUrlCust}fintech/issue/dicts`,
  fintIssues: `${baseUrlCust}fintech/issues`,

  //? Invite Friend, Point
  invFrnd: `${baseUrlCust}inv-frnd`,
  pointHist: `${baseUrlCust}point-hists`,
  point: `${baseUrlCust}point`,
  pointConf: `${baseUrlCust}point-cnf`,
  fintechNotes: `${baseUrlCust}fintech/notes`,
  fintechNote: `${baseUrlCust}fintech/note`,
  custNotes: `${baseUrlCust}notes`,
  custNote: `${baseUrlCust}note`,
  custProds: `${baseUrlCust}prods`,

  custChangeProd: `${baseUrlCust}prod/default`,
  custProdDel: `${baseUrlCust}prod/delete`,
  custProd: `${baseUrlCust}prod`,
  docs: `${baseUrlCust}docs`,
};

const baseUrlEmp = "/admin/auth/";
export const emp = {
  emps: `${baseUrlEmp}emps`,
  emp: `${baseUrlEmp}emp`,
  roles: `${baseUrlEmp}roles`,
  role: `${baseUrlEmp}role`,
  empRoles: `${baseUrlEmp}emp/roles`,
  empRole: `${baseUrlEmp}emp/role`,
  empPrivs: `${baseUrlEmp}emp/privs`,
  empPriv: `${baseUrlEmp}emp/priv`,
  privs: `${baseUrlEmp}privs`,
  priv: `${baseUrlEmp}priv`,
  rolePrivs: `${baseUrlEmp}role/privs`,
  rolePriv: `${baseUrlEmp}role/priv`,
  getUsername: `${baseUrlEmp}user/name`,
  reportUsers: `${baseUrlEmp}rprt/users`, //? fake url to show active sub menu, not real endpoint
  deleteUser: `${baseUrlEmp}user/delete`,
  userNotCust: `${baseAuth}user/not-cust`,
};

const baseUrlBa = "/admin/ba/";
export const ba = {
  bankAccounts: `${baseUrlBa}bankacnts`,
  bankAccount: `${baseUrlBa}bankacnt`,
  accounts: `${baseUrlBa}acnts`,
  account: `${baseUrlBa}acnt`,
  products: `${baseUrlBa}prods`,
  product: `${baseUrlBa}prod`,
  nostros: `${baseUrlBa}nostros`,
  nostro: `${baseUrlBa}nostro`,
  stmts: `${baseUrlBa}stmts`,
  stmt: `${baseUrlBa}stmt`,
  stmtUnrec: `${baseUrlBa}stmt/unrec`,
  txn: `${baseUrlBa}txn`,
  txnOut: `${baseUrlBa}txn/out`,
  txnWithDp: `${baseUrlBa}txn/with-dp`,
  transrqsts: `${baseUrlBa}transrqsts`,
  transrqst: `${baseUrlBa}transrqst`,
  transrqstStts: `${baseUrlBa}transrqst/status`,
  transrqstSend: `${baseUrlBa}transrqst/send`,
  bankAcntBal: `${baseUrlBa}bankacnt`,
  config: `${baseUrlBa}config`,
  dicts: `${baseUrlBa}dicts`,

  txnBa: `${baseUrlBa}txn/ba`,
};

const baseUrlDp = "/admin/dp/";
export const dp = {
  accounts: `${baseUrlDp}acnts`,
  account: `${baseUrlDp}acnt`,
  products: `${baseUrlDp}prods`,
  product: `${baseUrlDp}prod`,
  txn: `${baseUrlDp}txn`,
  finTxn: `${baseUrlDp}fin/txn`,
  acnt2acnt: `${baseUrlDp}fin/txn/dp`,
  acnt2ln: `${baseUrlDp}fin/txn/ln`,
  dpToBank: `${baseUrlDp}/txn/bank/exp`,
};

const baseUrlLn = "/admin/ln/";
export const ln = {
  clses: `${baseUrlLn}clses`,
  cls: `${baseUrlLn}cls`,
  acntClsChange: `${baseUrlLn}acnt/cls`,
  account: `${baseUrlLn}acnt`,
  accountCreate: `${baseUrlLn}acnt/create`,
  accounts: `${baseUrlLn}acnts`,
  acntPymntPrty: `${baseUrlLn}acnt/pymnt-prty`,
  acntIsExt: `${baseUrlLn}acnt/isext`,
  application: `${baseUrlLn}app`,
  applications: `${baseUrlLn}apps`,
  applicationStatus: `${baseUrlLn}app/status`,
  acntSchds: `${baseUrlLn}acnt/schd`,
  acntSchdHists: `${baseUrlLn}acnt/schd/hists`,
  acntRepayExt: `${baseUrlLn}acnt/repayext`,
  products: `${baseUrlLn}prods`,
  product: `${baseUrlLn}prod`,
  productAmtTerms: `${baseUrlLn}prod/terms`,
  productAmtTerm: `${baseUrlLn}prod/term`,
  dicts: `${baseUrlLn}dicts`,
  productGLs: `${baseUrlLn}prod/gls/`,
  productGL: `${baseUrlLn}prod/gl`,
  txn: `${baseUrlLn}txn`,
  finTxn: `${baseUrlLn}fin/txn`,
  extRequests: `${baseUrlLn}acnt/extrqsts`,
  extRequest: `${baseUrlLn}acnt/extrqst`,
  arrHist: `${baseUrlLn}acnt/arr-hist`,
  taxChange: `${baseUrlLn}acnt/issad`,
  productDefault: `${baseUrlLn}product/def`,

  //! LN ACNT TXN
  acntCorrBaseInt: `${baseUrlLn}fin/txn/corr/acc-base-int`,
  acntCorrDueBaseInt: `${baseUrlLn}fin/txn/corr/due-base-int`,
  acntCorrFineInt: `${baseUrlLn}fin/txn/corr/fine-int`,
  acntCorrPrincBal: `${baseUrlLn}acnt/txn/corr/princ-bal`,
  acntObFine: `${baseUrlLn}acnt/txn/ob/fine`,
  acntObBase: `${baseUrlLn}acnt/txn/ob/base`,
  acntPrvnPay: `${baseUrlLn}acnt/txn/prvn/pay`,
  //!

  acntChangeLo: `${baseUrlLn}account/change-lo`,
  custProds: `${baseUrlLn}cust/prods`,
  acntNotes: `${baseUrlLn}acnt/notes`,
  acntNote: `${baseUrlLn}acnt/note`,
  acntNoteTypes: `${baseUrlLn}dicts`,
};

const baseUrlSms = "/admin/sms/";
export const sms = {
  body: `${baseUrlSms}body`,
  sendTxt: `${baseUrlSms}send`,
};

const baseUrlFee = "/admin/fee/";
export const mainFee = {
  feeMainList: `${baseUrlFee}main/list`,
  feeMain: `${baseUrlFee}main`,
  feeConfigList: `${baseUrlFee}config/list`,
  feeConfig: `${baseUrlFee}config`,
  interval: `${baseUrlFee}interval`,
  main: `${baseUrlFee}main`,
};

const baseUrlPa = "/admin/pa/";
export const pa = {
  dicts: `${baseUrlPa}dicts`,
  fee: `${baseUrlPa}fee/main`,
  business: `${baseUrlPa}buses`,
  banks: `${baseUrlPa}banks`,
  branches: `${baseUrlPa}brchs`,
  branch: `${baseUrlPa}brch`,
  brchtimetbl: `${baseUrlPa}brch/timetbl`,
  cities: `${baseUrlPa}city`,
  city: `${baseUrlPa}city`,
  dists: `${baseUrlPa}dist`,
  dist: `${baseUrlPa}dist`,
  comps: `${baseUrlPa}comp`,
  comp: `${baseUrlPa}comp`,
  subDists: `${baseUrlPa}subdist`,
  subDist: `${baseUrlPa}subdist`,
  compAcnts: `${baseUrlPa}comp-acnts`,
  profs: `${baseUrlPa}profs`,
  educations: `${baseUrlPa}edus`,
  relationType: `${baseUrlPa}relation/type`,
  calendar: `${baseUrlPa}calendar`,
  cals: `${baseUrlPa}cals`,
  cal: `${baseUrlPa}cal`,
  calspcls: `${baseUrlPa}calspcls`,
  calspcl: `${baseUrlPa}calspcl`,
  calspclDate: `${baseUrlPa}calspcl/date`,
  calspclType: `${baseUrlPa}calspcl/type`,
  nations: `${baseUrlPa}nation`,
  nation: `${baseUrlPa}nation`,
  confs: `${baseUrlPa}confs`,
  infoSrcs: `${baseUrlPa}info-srcs`,

  //? Fint Issue
  fintIssues: `${baseUrlPa}fintech/issues`,
  docs: `${baseUrlPa}docs`,
  doc: `${baseUrlPa}doc`,
  templates: `${baseUrlPa}templates`,
  template: `${baseUrlPa}template`,
  cnf: `${baseUrlPa}conf`,
  newsList: `${baseUrlPa}newslist`,
  news: `${baseUrlPa}news`,
};

const baseUrlRprt = "/admin/rprt/";
export const rprt = {
  reports: `${baseUrlRprt}reports`,
  report: `${baseUrlRprt}report`,
  dataset: `${baseUrlRprt}dataset`,
  download: `${baseUrlRprt}dataset/download`,
  rprtUsers: `${baseUrlRprt}users`,
  rprtUser: `${baseUrlRprt}user`,
};

const baseUrlErr = "/admin/err/";
export const err = {
  msgs: `${baseUrlErr}dlx/list`,
  msg: `${baseUrlErr}dlx`,
};

const baseUrlDashboard = "/admin/dashboard/";
export const dashboard = {
  fint: `${baseUrlDashboard}cust/fint`,
  cntrCount: `${baseUrlDashboard}cntr/count`,
  errCount: `${baseUrlDashboard}err/count`,
};
